// An admin action's failure, said plainly: members get 403 and the page says so instead of hiding
// the action (plan step 2.2); 429 and 409 have their own words.
import { isApiError } from '../api/client'
import { useI18n } from '../i18n'

export function ActionError({ error }: { error: unknown }) {
  const { t } = useI18n()
  if (!error) return null
  return (
    <p role="alert" className="notice error">
      {isApiError(error, 403)
        ? t('settings.adminOnly')
        : isApiError(error, 429)
          ? t('settings.rateLimited')
          : isApiError(error, 409)
            ? t('settings.conflict')
            : t('state.failed')}
    </p>
  )
}
